module.exports = __webpack_public_path__ + "media/images/logos/Cornell-University-1e127742445cf627c5ee9cc7ee152f0b.svg";